import {NERDWALLET_DISCLOSURE, NERDWALLET_NOSQL_DISCLOSURE} from './constants';

export type ThemeType = 'atlas' | 'nerdwallet';

type DomainThemeMap = {
  theme: ThemeType;
  logo: string;
  disclosure: string;
  nosqlDisclosure: string;
  mainDomain: string;
};

/**
 * Domain to theme mapping configuration
 */
export const DOMAIN_THEME_MAP: Record<string, DomainThemeMap> = {
  'nerdwallet-test.zoefin.com': {
    theme: 'nerdwallet',
    logo: '/static/img/affiliates/nerdwallet_logo.svg',
    disclosure: NERDWALLET_DISCLOSURE,
    nosqlDisclosure: NERDWALLET_NOSQL_DISCLOSURE,
    mainDomain: 'https://nerdwallet-test.zoefin.com',
  },
  'nerdwallet.zoefin.com': {
    theme: 'nerdwallet',
    logo: '/static/img/affiliates/nerdwallet_logo.svg',
    disclosure: NERDWALLET_DISCLOSURE,
    nosqlDisclosure: NERDWALLET_NOSQL_DISCLOSURE,
    mainDomain: 'https://zoe.nerdwalletadvisors.com',
  },
  'zoe.nerdwalletadvisors.com': {
    theme: 'nerdwallet',
    logo: '/static/img/affiliates/nerdwallet_logo.svg',
    disclosure: NERDWALLET_DISCLOSURE,
    nosqlDisclosure: NERDWALLET_NOSQL_DISCLOSURE,
    mainDomain: 'https://zoe.nerdwalletadvisors.com',
  },
};

/**
 * Server-side theme detection for use in getServerSideProps or getInitialProps
 * @param host - The host header from the request
 * @returns The theme to use based on the host
 */
export const detectThemeFromHost = (host: string): ThemeType => {
  if (!host) return 'atlas';

  const hostname = host.toLowerCase().split(':')[0];

  return DOMAIN_THEME_MAP[hostname]?.theme ?? 'atlas';
};

export const getHostFromClient = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  const urlObj = new URL(window.location.href);

  return urlObj.host;
};

export const getAffiliateLogo = (host: string): string => {
  return (
    DOMAIN_THEME_MAP[host]?.logo || '/static/img/zoe-logo/Zoe_Logo_Blue.svg'
  );
};

export const isNerdWallet = (host: string): boolean => {
  return host.includes('nerdwallet');
};
